<template>
    <i class="icon-badge" title="Affiliate stage"> ENTHUSIAST</i>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderBadge',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 0 }
  }
}
</script>
